<template>
    <div class="container">
        <div class="row h-50">
        <div class="form-group col my-4">
            <h2 class="message">SendToCar</h2>
            <p>
                <label class="message" for="token">Auth Token</label>
                <input class="form-control"
                    id="authToken"
                    v-model="authToken"
                    type="text"
                    name="authToken">
                <label class="message" for="guid">GUID</label>
                <input class="form-control"
                    id="guid"
                    v-model="guid"
                    type="text"
                    name="guid">
                <label class="message" for="lat">Latitude</label>
                <input class="form-control"
                        id="lat"
                        v-model="lat"
                        type="number"
                        name="lat">
                <label class="message" for="long">Longitude</label>
                <input class="form-control"
                        id="long"
                        v-model="long"
                        type="number"
                        name="long">
                <label class="message" for="guid">POI Name</label>
                <input class="form-control"
                    id="poi_name"
                    v-model="poi_name"
                    type="text"
                    name="poi_name">
            </p>
            <div class="py-3" style="text-align: center">
                <button class="ty-button" v-on:click="sendLink">Send To Car</button>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
    export default {
        name:'sendtocar',
        data() {
            return{
                authToken:null,
                guid:null,
                lat:null,
                long:null,
                poi_name:null
            }
        },
        methods:{
            sendLink: function () {
            const devURL = 'https://ipapps-dev.b2c.tmnactservices.com/svc/sendtocar'

            this.axios.post(devURL ,{
            headers: {
                'Content-Type':'application/json',
                'Authorization':`Bearer ${this.authToken}`
            },
            data:{
                guid:this.guid,
                location:{
                    lat:this.lat,
                    long:this.long,
                },
                poi_name:this.poi_name,
                timestamp:Date.now()
            }
            }).then((response) => {
            // eslint-disable-next-line no-console
            console.log("message: ", response)
            alert(`Location sent to car`)
            }).catch((e) => {
            // eslint-disable-next-line no-console
            console.log("error: ", e)
            alert(`Location was not sent`,e)
            })
        }
        }
    }
</script>

<style lang="scss" scoped>

</style>